// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"46d3b744","237":"ddb6ab3d","453":"195b869a","720":"bc18f061"}[chunkId] + ".chunk.js";
};